import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoginService, Configuration, TokenResponse } from 'generated-sources/openapi';
import { Router } from '@angular/router';
import { AuthGuard } from '../auth.guard';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  email: string;
  password: string;
  working = false;

  constructor(private snackBar: MatSnackBar,
    private loginService: LoginService,
    private cfg: Configuration,
    private router: Router,
    private authGuard: AuthGuard) { }

  ngOnInit() {
  }

  forgot() {
    window.location.href = 'https://pwd.life.edu/';
  }

  tryLogin() {
    this.working = true;
    this.loginService.authLoginPost({
      email: this.email,
      password: this.password
    }).subscribe((r) => {
      this.working = false;
      console.log(r);
      this.cfg.accessToken = r.access_token;
      window.localStorage.setItem('login', JSON.stringify(r));
      this.authGuard.updateToken(r);
      this.router.navigate(['/msgs']);
    }, (err) => {
      this.working = false;
      this.authGuard.updateToken(null);
      this.snackBar.open('Could not login', null, {
        duration: 3000
      });
    });
  }

}
